import request from '@/utils/request'

// -------------------- /goods/statistics/ --------------------

// 交易指导价
export function getGuidePrice(goodsLevelId) {
    return request({
        url: '/goods/statistics/guide/price',
        method: 'get',
        params: {
            goodsLevelId
        }
    })
}

// K线数据
export function getKline(params) {
    return request({
        url: '/goods/statistics/kline',
        method: 'get',
        params
    })
}

// 最新价格
export function getPrice(goodsLevelId, sumType = 1) {
    return request({
        url: '/goods/statistics/lastest/price',
        method: 'get',
        params: { goodsLevelId, sumType }
    })
}

// 入库商品统计
export function getWarehousingNum(query) {
    return request({
        url: '/goods/statistics/storage',
        method: 'get',
        params: query
    })
}

// 挂牌商品统计
export function getOnLineNum(query) {
    return request({
        url: '/goods/statistics/onLine',
        method: 'get',
        params: query
    })
}

// -------------------- /goods/category/ --------------------

// 查询商品列表-仅启用状态
export function getGoods(query) {
    return request({
        url: '/goods/category/list/withLevel',
        method: 'get',
        params: query
    })
}

// 交易大厅-商品分类
export function getGoodsCategory(goodsLevelId) {
    return request({
        url: '/goods/category/list/withLevel',
        method: 'get',
        params: { status: 0 }
    })
}

// 商品等级详情
export function getProductLevelDetail(goodsLevelId) {
    return request({
        url: `/goods/category/level/detial/${goodsLevelId}`,
        method: 'get'
    })
}

// -------------------- /goods/trade/ --------------------

// 交易大厅-价格变动
export function getTradePriceOrderList(orderType, sumType = 1, limit) {
    return request({
        url: '/goods/trade/record/change/price',
        method: 'get',
        params: { orderType, sumType, limit }
    })
}

// 交易大厅-热门
export function getTradeHotOrderList(limit, sumType) {
    return request({
        url: '/goods/trade/record/hot',
        method: 'get',
        params: { limit, sumType }
    })
}

// -------------------- /goods/manage/ --------------------

// 成交公示-更多
export function getReachPublicityMore(params) {
    return request({
        url: '/goods/manage/success/deal/view/more',
        method: 'get',
        params
    })
}

// 交易大厅-列表
export function getDealList(params) {
    return request({
        url: '/goods/manage/member/tradinghall/list',
        method: 'get',
        params
    })
}

// 交易大厅-详情
export function getDealdetails(id) {
    return request({
        url: '/goods/manage/member/tradinghall/detail/' + id,
        method: 'get'
    })
}

// 摘牌商品列表
export function getProductZpList(goodsLevelId) {
    return request({
        url: '/goods/manage/app/delistings',
        method: 'get',
        params: { goodsLevelId, limit: 20 }
    })
}

// 获取挂牌商品列表
export function getSellList(params) {
    return request({
        url: '/goods/manage/member/list',
        method: 'get',
        params
    })
}

// 修改发布商品
export function goodsPublishAmend(data) {
    return request({
        url: '/goods/manage/sell/rejoin/online',
        method: 'post',
        data
    })
}

// 商品挂牌(上架)
export function goodsPutaway(data) {
    return request({
        url: '/goods/manage/sell/online',
        method: 'post',
        data
    })
}

// 撤单
export function goodsSellBackout(data) {
    return request({
        url: '/goods/manage/backout',
        method: 'put',
        data
    })
}

// 查询详细信息
export function goodsDetail(id) {
    return request({
        url: '/goods/manage/member/detail/' + id,
        method: 'get',
    })
}

// 删除挂牌记录
export function deleteGoods(id) {
    return request({
        url: '/goods/manage/' + id,
        method: 'delete',
    })
}

// -------------------- /goods/manage/publish/ --------------------

// 获取采购信息列表
export function getPurchaseList(params) {
    return request({
        url: '/goods/manage/publish/goods/list',
        method: 'get',
        params
    })
}

// 采购信息发布
export function purchasePublish(data) {
    return request({
        url: '/goods/manage/publish/goods/online',
        method: 'post',
        data
    })
}

// 修改采购信息(重新挂牌)
export function purchaseRedact(data) {
    return request({
        url: '/goods/manage/publish/goods/rejoin',
        method: 'put',
        data
    })
}

// 采购信息详情
export function purchaseDetail(id) {
    return request({
        url: '/goods/manage/publish/goods/detail/' + id,
        method: 'get'
    })
}

// 采购信息撤牌
export function purchaseBackout(data) {
    return request({
        url: '/goods/manage/publish/goods/backout',
        method: 'put',
        data
    })
}

// 删除采购信息记录
export function delPurchaseInfos(id) {
    return request({
        url: '/goods/manage/publish/goods/remove/' + id,
        method: 'delete'
    })
}

// -------------------- /goods/monitorEquip/ --------------------

// 获取监控设备列表
export function getMonitoredList(params) {
    return request({
        url: '/goods/monitorEquip/page',
        method: 'get',
        params
    })
}

// 新增监控设备
export function addMonitored(data) {
    return request({
        url: '/goods/monitorEquip',
        method: 'post',
        data
    })
}

// 修改设备信息
export function amendMonitored(data) {
    return request({
        url: '/goods/monitorEquip',
        method: 'put',
        data
    })
}

// 查询设备详情
export function monitoredDetail(id) {
    return request({
        url: '/goods/monitorEquip/' + id,
        method: 'get',
    })
}

// 删除设备信息
export function deleteMonitored(id) {
    return request({
        url: '/goods/monitorEquip/' + id,
        method: 'delete'
    })
}

// -------------------- /goods/warehouse/ --------------------

// 查询所有仓库
export function getWarehouseAll(params) {
    return request({
        url: '/goods/warehouse/list',
        method: 'get',
        params
    })
}

// 分页查询仓库管理列表
export function getWarehouseList(query) {
    return request({
        url: '/goods/warehouse/page',
        method: 'get',
        params: query
    })
}

// 新增仓库
export function addWarehouse(data) {
    return request({
        url: '/goods/warehouse',
        method: 'post',
        data: data
    })
}

// 修改仓库
export function modifyWarehouse(data) {
    return request({
        url: '/goods/warehouse',
        method: 'put',
        data: data
    })
}

// 查看仓库详情
export function getWarehouseDetail(id) {
    return request({
        url: '/goods/warehouse/' + id,
        method: 'get',
    })
}

// 删除仓库
export function deleteWarehouse(id) {
    return request({
        url: '/goods/warehouse/' + id,
        method: 'DELETE',
    })
}

// 修改仓库信息查询并添加数据修改状态
export function getWarehouseVerify(id) {
    return request({
        url: '/goods/warehouse/verify/' + id,
        method: 'get',
    })
}

// 查询入库信息列表
export function getInBoundList(query) {
    return request({
        url: '/goods/warehouse/logs/in/list',
        method: 'get',
        params: query
    })
}

// 查询出库信息列表
export function getOutBoundList(query) {
    return request({
        url: '/goods/warehouse/logs/out/list',
        method: 'get',
        params: query
    })
}

// 查询出入库信息详情
export function getDetailInfo(id) {
    return request({
        url: '/goods/warehouse/logs/' + id,
        method: 'get',
    })
}

// -------------------- /goods/stock/ --------------------

// 根据商品查询仓库
export function getWarehouse(params) {
    return request({
        url: '/goods/stock/outwarehouse',
        method: 'get',
        params
    })
}

// 分页查询库存
export function getStockList(query) {
    return request({
        url: '/goods/stock/page',
        method: 'get',
        params: query
    })
}

// 商品入库
export function addStock(data) {
    return request({
        url: '/goods/stock',
        method: 'post',
        data: data
    })
}

// 商品出库
export function outStock(data) {
    return request({
        url: '/goods/stock/outStock',
        method: 'post',
        data: data
    })
}

// 查看库存商品详情
export function getStockDetail(query) {
    return request({
        url: '/goods/stock/info',
        method: 'get',
        params: query
    })
}
